<app-header></app-header>
<div class="main-wrapper">
  <div class="page-wrapper full-page">
    <div class="page-content d-flex align-items-center justify-content-center">

      <div class="row w-100 mx-0 auth-page">
        <div class="col-md-8 col-xl-6 mx-auto d-flex flex-column align-items-center">
          <img src="assets/images/404.png" class="img-fluid mb-2" alt="404">
          <h1 class="font-weight-bold mb-22 mt-2 tx-80">{{ 'GENERAL.404_TITLE1' | translate }} </h1>
          <h4 class="m-2">{{ 'GENERAL.404_TITLE2' | translate }}</h4>
          <h5 class="mb-3 text-center">{{ 'GENERAL.404_TITLE3' | translate }}</h5>
          <a routerLink="/lectures" class="btn btn-primary">{{ 'GENERAL.404_BACK' | translate }}</a>
        </div>
      </div>
    </div>
  </div>
</div>